'use client'

import { useTenantButtonColor } from '@/components/TenantButtonColorContext'
import { ctaButtonColorStyle } from '@/lib/colorUtils'
import { FC } from 'react'

export interface InfoCTAButtonProps {
  ctaUrl: string
  ctaLabel?: string | null
  onTrackCtaClick?: () => void
  /**
   * 別タブを開く直前に動画を止めるためのフック。渡さないと、遷移先を見ている間も
   * 裏のタブで動画が進み続け、音も鳴り続ける。
   */
  onPauseVideo?: () => void
}

const InfoCTAButton: FC<InfoCTAButtonProps> = ({ ctaUrl, ctaLabel, onTrackCtaClick, onPauseVideo }) => {
  const ctaStyle = ctaButtonColorStyle(useTenantButtonColor())
  const handleCTAClick = () => {
    onTrackCtaClick?.()
    onPauseVideo?.()
    window.open(ctaUrl, '_blank')
  }

  // 配置（下端の追従スタック）は呼び出し側が持つ。ここはボタン本体だけを返す。
  // 見た目は自前の <style> で完結させる。TILE のパネルだけでなく BOX など別レイアウトから
  // 呼んでも同じCVボタンになるようにするため、親の CSS には依存させない（動画個別ページの
  // CtaButton と同じアクセント色 / 30px ピル / 影）。
  return (
    <>
      <style>{`
        .info-cta-button {
          width: 100%;
          padding: 14px 24px;
          background: var(--video-brand-color, var(--video-accent-color, #1d48af));
          color: white;
          font-size: 15px;
          font-weight: bold;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          transition: all 200ms ease;
          box-shadow: 0 4px 12px color-mix(in srgb, var(--video-brand-color, var(--video-accent-color)) 30%, transparent);
        }

        .info-cta-button:hover {
          background: var(--video-brand-hover-color, var(--video-accent-hover-color, #17398c));
          transform: translateY(-2px);
          box-shadow: 0 6px 16px color-mix(in srgb, var(--video-brand-color, var(--video-accent-color)) 40%, transparent);
        }

        .info-cta-button:active {
          transform: translateY(0);
        }
      `}</style>
      <button type="button" className="info-cta-button" style={ctaStyle} onClick={handleCTAClick}>
        {ctaLabel || '採用情報へ'}
      </button>
    </>
  )
}

export default InfoCTAButton
